import { Table } from 'react-bootstrap';
import { useContext, useEffect } from 'react';
import { Context } from '../../../components/Context';
import { PageLoader } from '../../../components/Helper';
import moment from 'moment';
import { fetchData, REPORT_SMADEX } from '../../../components/Service';
import $ from 'jquery';
import 'datatables.net-dt/css/dataTables.dataTables.min.css'; // DataTables CSS
import 'datatables.net'; // DataTables JS
import _ from "lodash";

const SmadexReport = (props) => {
    const [context] = useContext(Context)

    const getReport = (e) => {
        PageLoader(true)
        fetchData(REPORT_SMADEX + "?orgId=" + props?.orgId, 'GET', "", true, false, (res) => {
            PageLoader(false)
            if (res.status === "success") {
                $('#smadexReport').DataTable({
                    data: res.records.data,
                    columns: [
                        { title: 'ID', data: 'id',
                            render: function(data) {
                                return '<span class="dt-id-block">'+data+'</span>';
                            }
                        },
                        { title: 'Name', data: 'name' },
                        { title: 'Status', data: 'status',
                            render: function (data) {
                                return data ? '<span class="status-block '+data.toLowerCase()+'">'+data.toUpperCase()+'</span>' : "<span class='status-block inactive'>INACTIVE</span>";
                            }
                         },
                        // { title: 'Actions', data: null, defaultContent: "" },
                        { title: 'Lines Active', data: null, defaultContent: 0 },
                        { title: 'Total Spend', data: null, defaultContent: 0,
                            render: function(data) {
                                return data > 0 ? '$ ' + data : 0;
                            }
                        },
                        { title: 'Daily Budget', data: 'budget.dailyCap', defaultContent: 0,
                            render: function(data) {
                                return data > 0 ? '$ ' + data : 0;
                            }
                        },
                        { title: 'Total Budget', data: 'budget.totalCap', defaultContent: 0,
                            render: function(data) {
                                return data > 0 ? '$ ' + data : 0;
                            }
                        },
                        { title: 'CPM', data: null, defaultContent: 0,
                            render: function(data) {
                                return data > 0 ? '$ ' + data : 0;
                            }
                        },
                        { title: 'CPC', data: null, defaultContent: 0,
                            render: function(data) {
                                return data > 0 ? '$ ' + data : 0;
                            }
                        },
                        { title: 'CTR', data: null, defaultContent: 0,
                            render: function(data) {
                                return data > 0 ? data+ '%' : 0;
                            }
                        },
                        { title: 'Impressions', data: null, defaultContent: 0 },
                        { title: 'Clicks', data: null, defaultContent: 0 },
                        { title: 'Landings', data: null, defaultContent: 0 },
                        { title: 'Start Date', data: 'startsAt',
                            render: function (data) {
                                return moment(new Date(data).toString()).format('YYYY-MM-DD');
                            }
                         },
                        { title: 'End Date', data: 'expiresAt',
                            render: function (data) {
                                return moment(new Date(data).toString()).format('YYYY-MM-DD');
                            }
                        },
                    ],
                    destroy: true, // Allow re-initialization
                });
            } else {
                // displayError(res.errors)
            }
        });
    }

    useEffect(() => {
        if(context && context.id){
            getReport()
        }
    }, [])

    return (
        <>
            <Table id="smadexReport" responsive bordered hover></Table>
        </>
    );
};

export default SmadexReport;
